import React from 'react';

import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid2';
import Fade from '@mui/material/Fade';

import { useDebriefApp } from 'ff/debrief/hooks';
import SegmentDetailsPanel from 'ff/debrief/layouts/SegmentDetailsPanel';

import ScoringDetails from 'ff/debrief/components/scoringDetails/ScoringDetails';
import AltitudeSpeedChart from 'ff/debrief/components/charts/AltitudeSpeedChart';
import SegmentDetailsTitle from 'ff/debrief/components/scoringDetails/SegmentDetailsTitle';
import PanelDivider from 'ff/debrief/components/scoringDetails/PanelDivider';

const SegmentDetails = React.forwardRef<HTMLDivElement, {}>((props, ref) => {
    const { selectedSegment } = useDebriefApp();
    const [showScoreDetails, setShowScoreDetails] = React.useState(true);
    const hasScoringDetails =
        selectedSegment?.scoringDetails !== undefined &&
        selectedSegment?.scoringDetails?.length > 0;
    return (
        <SegmentDetailsPanel ref={ref} {...props}>
            <Paper sx={{ maxHeight: 350 }}>
                <SegmentDetailsTitle
                    segmentLabel={selectedSegment?.label || 'Entire Flight'}
                    score={selectedSegment?.score || undefined}
                />
                <Grid spacing={1} alignItems="stretch" px={2} container>
                    <Grid size="grow">
                        <AltitudeSpeedChart />
                    </Grid>
                    <Fade in={hasScoringDetails} unmountOnExit>
                        <Grid size={'auto'}>
                            <PanelDivider
                                showScoreDetails={showScoreDetails}
                                onClick={() =>
                                    setShowScoreDetails(!showScoreDetails)
                                }
                            />
                        </Grid>
                    </Fade>
                    <Fade
                        in={hasScoringDetails && showScoreDetails}
                        unmountOnExit
                    >
                        <Grid size="grow" flexGrow={0.7}>
                            <ScoringDetails
                                segmentLabel={selectedSegment?.label}
                                segmentScore={selectedSegment?.score}
                                scoringDetails={selectedSegment?.scoringDetails}
                            />
                        </Grid>
                    </Fade>
                </Grid>
            </Paper>
        </SegmentDetailsPanel>
    );
});

SegmentDetails.displayName = 'SegmentDetails';

export default SegmentDetails;
